import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import HotRanking from "@/pages/home/components/HotRanking";
import IntroSection from "@/pages/home/components/IntroSection";
import WorkCard from "@/components/feature/WorkCard";
import SectionTitle from "@/components/base/SectionTitle";
import { works } from "@/mocks/works";
import { sortWorks } from "@/utils/work";

export default function Home() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = window.setTimeout(() => setLoading(false), 450);
    return () => window.clearTimeout(timer);
  }, []);

  const latestWorks = useMemo(
    () => sortWorks(works, "latest").slice(0, 9),
    []
  );
  const rankingWorks = useMemo(
    () => sortWorks(works, "popular").slice(0, 10),
    []
  );

  return (
    <div className="w-full animate-fadeIn">
      <HeroCarousel />
      <CategoryQuickLinks />

      <section className="mx-auto w-full px-4 pb-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_320px]">
          <div>
            <SectionTitle
              title="最新影视作品"
              subtitle="近期更新与新增的国产原创影视内容"
              action={
                <Link
                  to="/category/movie"
                  className="hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-600 hover:text-accent-700 sm:flex"
                >
                  查看更多
                  <i className="ri-arrow-right-line" />
                </Link>
              }
            />

            {loading ? (
              <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 md:grid-cols-3 md:gap-5">
                {Array.from({ length: 6 }).map((_, index) => (
                  <div
                    key={index}
                    className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
                  >
                    <div className="aspect-[2/3] w-full animate-pulse bg-background-200" />
                    <div className="space-y-2 p-3">
                      <div className="h-4 w-3/4 animate-pulse rounded bg-background-200" />
                      <div className="h-3 w-1/2 animate-pulse rounded bg-background-200" />
                    </div>
                  </div>
                ))}
              </div>
            ) : latestWorks.length === 0 ? (
              <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 py-16 text-center">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-500">
                  <i className="ri-inbox-line text-2xl" />
                </span>
                <p className="mt-4 text-sm text-foreground-600">
                  暂无最新作品，敬请期待
                </p>
              </div>
            ) : (
              <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 md:grid-cols-3 md:gap-5">
                {latestWorks.map((work) => (
                  <WorkCard key={work.id} work={work} />
                ))}
              </div>
            )}
          </div>

          <aside className="lg:sticky lg:top-24 lg:self-start">
            <HotRanking works={rankingWorks} />
          </aside>
        </div>
      </section>

      <IntroSection />
    </div>
  );
}